type DOMCommentProps = {
  text: string
}

export const DOMComment = ({ text }: DOMCommentProps) => (
  <span
    dangerouslySetInnerHTML={{
      __html: `<!-- ${text} -->`,
    }}
  />
)
